"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createActions = createActions;
function createActions(prefix) {
    return {
        setFileUploadModalDescription: function (description) { return ({
            type: "".concat(prefix, "/SET_FILEUPLOAD_MODAL_DESCRIPTION"),
            payload: description
        }); },
        toggleModalStatus: function (fileId) { return ({
            type: "".concat(prefix, "/TOGGLE_FILEUPLOAD_MODAL_STATUS"),
            payload: fileId
        }); },
        setFileUploadFiles: function (files, baseUrl, parent, bidUuid, briefcaseUuid, letterUuid) { return ({
            type: "".concat(prefix, "/SET_FILEUPLOAD_FILES"),
            payload: {
                files: files,
                baseUrl: baseUrl,
                parent: parent,
                bidUuid: bidUuid,
                briefcaseUuid: briefcaseUuid,
                letterUuid: letterUuid
            }
        }); },
        resetCurrentUploadStatus: function (session) {
            if (session === void 0) { session = ''; }
            return ({
                type: "".concat(prefix, "/RESET_CURRENT_UPLOAD_STATUS"),
                payload: session
            });
        },
        toggleReplace: function (replace) { return ({
            type: "".concat(prefix, "/TOGGLE_REPLACE"),
            payload: replace
        }); },
        toggleUnzip: function (unzip) { return ({
            type: "".concat(prefix, "/TOGGLE_UNZIP"),
            payload: unzip
        }); },
        uploadSessionCreated: function (payload, session, project) { return ({
            type: "".concat(prefix, "/UPLOAD_SESSION_CREATED"),
            payload: {
                payload: payload,
                session: session,
                project: project
            }
        }); },
        uploadSessionFailed: function (error) { return ({
            type: "".concat(prefix, "/UPLOAD_SESSION_FAILED"),
            payload: error
        }); },
        fileUploadFileRequestAction: function (payload) { return ({
            type: "".concat(prefix, "/FILEUPLOAD_FILE_REQUEST"),
            payload: payload
        }); },
        fileuploadFileUpdateStatus: function (percent, loadedSize, totalSize, uuid) { return ({
            type: "".concat(prefix, "/FILEUPLOAD_FILE_UPDATE"),
            payload: [{ uuid: uuid, percent: percent, loadedSize: loadedSize, totalSize: totalSize }]
        }); },
        fileuploadFileSuccess: function (projectId, uuid, session) { return ({
            type: "".concat(prefix, "/FILEUPLOAD_FILE_SUCCESS"),
            payload: [{ uuid: uuid, projectId: projectId, session: session }]
        }); },
        fileuploadFileCancel: function (uuid) { return ({
            type: "".concat(prefix, "/FILEUPLOAD_FILE_CANCEL"),
            payload: [{ uuid: uuid }]
        }); },
        fileuploadFileFailure: function (message, uuid) { return ({
            type: "".concat(prefix, "/FILEUPLOAD_FILE_FAILURE"),
            payload: [{ message: message, uuid: uuid }]
        }); },
        abortSessionSuccessAction: function () { return ({
            type: "".concat(prefix, "/ABORT_SESSION_SUCCESS")
        }); },
        abortSessionFailureAction: function (e) { return ({
            type: "".concat(prefix, "/ABORT_SESSION_FAILURE"),
            payload: e
        }); },
        fileUploadRequestAction: function (structure, parent, unzip, replace, fileId, showUploadStatusBar, bidUuid, briefcaseUuid, letterUuid) { return ({
            type: "".concat(prefix, "/FILEUPLOAD_REQUEST"),
            payload: {
                structure: structure,
                parent: parent,
                unzip: unzip,
                replace: replace,
                fileId: fileId,
                showUploadStatusBar: !!showUploadStatusBar,
                bidUuid: bidUuid,
                briefcaseUuid: briefcaseUuid,
                letterUuid: letterUuid
            }
        }); },
        fileuploadDone: function () { return ({
            type: "".concat(prefix, "/FILEUPLOAD_DONE")
        }); },
        fileUploadCancelAction: function (session) { return ({
            type: "".concat(prefix, "/FILEUPLOAD_CANCEL"),
            payload: session
        }); },
        checkDuplicateFilesRequest: function (files, parent) { return ({
            type: "".concat(prefix, "/CHECK_DUPLICATE_FILES_REQUEST"),
            payload: {
                files: files,
                parent: parent
            }
        }); },
        checkDuplicateFilesSuccess: function (hasDuplicate) { return ({
            type: "".concat(prefix, "/CHECK_DUPLICATE_FILES_SUCCESS"),
            data: hasDuplicate
        }); },
        checkDuplicateFilesFailure: function (hasDuplicate) { return ({
            type: "".concat(prefix, "/CHECK_DUPLICATE_FILES_FAILURE"),
            data: hasDuplicate
        }); }
    };
}
